import { api } from '@/core/api/client'

export interface Location {
  id: string
  name: string
  address?: string
  notes?: string
  isActive?: boolean
}

const locationsCollection = api.collection<Location>('locations')

export async function getAllLocations(): Promise<Location[]> {
  return locationsCollection.getFullList()
}
